module.exports = __webpack_public_path__ + "img/icon_paint_232.903af478.png";